import React from "react";
import { Phone } from "lucide-react";
import { company } from "../mock";
import { formatPhoneFR } from "../utils/phone";
import { useLocation, useNavigate } from "react-router-dom";

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (location.pathname !== "/") {
      navigate("/");
      // After navigation, browser will render hero at top
      return;
    }
    const el = document.getElementById("accueil");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="dark-header">
      <div
        className="dark-logo heading-2"
        onClick={handleLogoClick}
        role="link"
        tabIndex={0}
        onKeyDown={(e) => (e.key === "Enter" ? handleLogoClick() : null)}
        style={{ color: "var(--text-primary)", cursor: "pointer" }}
      >
        COM INVEST
      </div>
      <a href={`tel:${company.phone}`} className="btn-primary phone-cta dark-button-animate" aria-label={`Appeler ${formatPhoneFR(company.phone)}`}>
        <span className="icon" aria-hidden>
          <Phone size={18} />
        </span>
        <span className="button-text">{formatPhoneFR(company.phone)}</span>
      </a>
    </header>
  );
};
